import type { FaireProductEntity } from "../../entity_types/product";

export const p_5r5pw65mve: FaireProductEntity = {
  token: "p_5r5pw65mve",
  type: "product",
  name: "Adjustable Evil Eye Ring, Gold Silver Statement Ring, Zircon Ring",
  brandToken: "b_ur24ckegrz",
  brandName: "Evileyefavor",
  imageUrl:
    "https://cdn.faire.com/fastly/17658bc2507721ec0c6640a167c06df04aeaaa16320b589085c1024ffc3621c6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5cb5c8068c35d0250bac42b7365e5421440de1fba1c27a9c7feee4e5cc803a45.jpeg",
    "https://cdn.faire.com/fastly/8b46ceaecc7f68fd36c7184bf099d6dd2c5d6125f037ea10c8f94cd22c277569.jpeg",
    "https://cdn.faire.com/fastly/ea3c2f37608826b2cf0805f51d638b7aa23a90277b1324b25075a8081b92f0c9.jpeg",
    "https://cdn.faire.com/fastly/96640d3fa069ef290c186542098b71f2232bd3a285167abf0e0a61878e1d2e3b.jpeg",
    "https://cdn.faire.com/fastly/00c4b0d63791319dde600e881561f2775e57e9721b2f218a96dd4c64d5731a27.jpeg",
    "https://cdn.faire.com/fastly/a2bd5c33b090b15335adb6199ff4c6cf29d30ec46882f05d66e331c6f3099ddf.jpeg",
    "https://cdn.faire.com/fastly/483e8e675b1a11cd9e0b2606374a8e3c35e10099ea554e6ccbc146317ac4ea2a.jpeg",
    "https://cdn.faire.com/fastly/0977f726ee12fc172fd86ee0f3a172ea80c0a0d747ca3b42041cc9169ed8b858.jpeg",
    "https://cdn.faire.com/fastly/e758a06e0499819929acec2025c3770d17c8ce1fac6e3c8374e8c48841d84126.jpeg",
  ],
  priceDollars: 9.35,
  description:
    'Evil eye ring, zircon charm bead, adjustable ring, blue evil eye bead, silver ring, gold ring, statement ring, everyday greek evil eye ring\n\n🌟 Evil eye bead size: 6mm\n\n🌟 Please choose band color during checkout; \n- Gold\n- Silver\n\n🌟 These evil eye rings are ADJUSTABLE. These are suitable for every sizes. \n\n🌟 These evil eye rings can be used as JOINT RINGS as well.""',
  tags: [],
  msrpDollars: 15.59,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:11.709Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
